import { render } from "./MessageList.vue?vue&type=template&id=1c5ad064"
import script from "./MessageList.vue?vue&type=script&lang=js"
export * from "./MessageList.vue?vue&type=script&lang=js"

import "./MessageList.vue?vue&type=style&index=0&id=1c5ad064&lang=css"

import exportComponent from "D:\\Xoan\\asp-user\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__